/** FinBERT score formatting shared by the home specimen and ticker page. */

export type SentimentLabel = 'positive' | 'neutral' | 'negative';

export function formatScore(score: number): string {
  return `${score >= 0 ? '+' : ''}${score.toFixed(2)}`;
}

export function formatPercent(probability: number): string {
  return `${Math.round(probability * 100)}%`;
}

export function labelFor(positive: number, negative: number, neutral: number): SentimentLabel {
  const top = Math.max(neutral, positive, negative);
  if (top === neutral) return 'neutral';
  return top === positive ? 'positive' : 'negative';
}

/** Tone of an aggregate score; a small dead zone keeps noise reading as neutral. */
export function toneFor(score: number): SentimentLabel {
  if (score > 0.05) return 'positive';
  if (score < -0.05) return 'negative';
  return 'neutral';
}
